import HeroBg from "public/pocAsService/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Run your Proof-of-Concept projects now",
    link: "contact-us",
  },
  title: "Validate & Test Before Full Deployment",
  desc: "Experience real-world performance and integration clarity with fully supported, low-risk Proof-of-Concept deployments.",
  image: HeroBg,
  cmlPowered: true,
};
